/* Campaigns tie sites and tasks back to the partnership or marketing push that
created them (eg. the Google × fixed.net cleanup programme).

A campaign is assigned to a promotion in the promotion admin form. Anything
provisioned with one of that promotion's coupons is then stamped with the
campaign key by the backend, which is what the admin site/task list views below
filter on. Adding an entry here gives a campaign its own list views – no other
change is needed.

`icon` (path to an image under `public/`) and `background` (a CSS
background-image, painted over the row) are used to highlight the campaign's
tasks in list views – see `getCampaignIcon`, `getCampaignClass` and
`getCampaignStyle` below, and the `.is-campaign` styles in `ListCard.vue`. */

/* Google brand colours, as a faint diagonal band across the right hand third
of the row, fading in from its left edge. */
const googleGradient = [
  "linear-gradient(140deg",
  "rgba(66, 133, 244, 0) 66%",
  "rgba(66, 133, 244, 0.16) 76%", // Blue
  "rgba(52, 168, 83, 0.16) 84%", // Green
  "rgba(251, 188, 5, 0.16) 92%", // Yellow
  "rgba(234, 67, 53, 0.16) 100%)" // Red
].join(", ");

export const campaigns = {
  GOOGLE_PARTNERSHIP: {
    key: "google-partnership",
    label: "Google Partnership",
    icon: "/assets/images/interface/logos/google-g.svg",
    background: googleGradient
  }
};

export const campaignList = Object.values(campaigns);

export const campaignKeys = campaignList.map(campaign => campaign.key);

export const getCampaign = key =>
  campaignList.find(campaign => campaign.key === key) || null;

/* Attributes for an `<img class="campaign-icon">` marking a task/site as
belonging to a campaign, or null if the key isn't a known campaign (or has no
icon). */
export const getCampaignIcon = key => {
  const campaign = getCampaign(key);
  if (!campaign || !campaign.icon) return null;
  return {
    src: campaign.icon,
    alt: campaign.label,
    title: `${campaign.label} task`
  };
};

/* Class + style to apply to a `list-card` for a campaign's tasks/sites.
`is-campaign` makes `ListCard.vue` paint the campaign's `background` (read from
the `--campaign-background` custom property) over the row; `is-campaign-<key>`
is there for any campaign specific overrides. Both return null/{} for unknown
keys. */
export const getCampaignClass = key =>
  getCampaign(key) ? `is-campaign is-campaign-${key}` : null;

export const getCampaignStyle = key => {
  const campaign = getCampaign(key);
  return campaign && campaign.background
    ? { "--campaign-background": campaign.background }
    : {};
};

export default campaigns;
